import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import {  } from 'react-icons/fa';
import PageLoader from '../components/PageLoader';

const KYC = () => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [kYCCheck, setKYCCheck] = useState([]);
    const [kYCFaild, setKYCFaild] = useState([]);
    const [showKYCFaild, setShowKYCFaild] = useState(false);
    const [showKYCCheck, setShowKYCCheck] = useState(true);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');

    const handleBankVerification = async (customer) => {
        setIsLoading(true); 
        try {
            const { id } = customer;
            const response = await axios.post(`${base_url}/api1/account/saveAccountNum?id=${id}`,);
            if (response.status === 200) {
                alert(`Account number ${id} IFSC Checked successfully`);
            } else {
                alert('Failed to save account number and IFSC code');
            }
        } catch (error) {
            console.error('Error saving account data:', error.response?.data || error.message);
            alert('Error saving account data');
        }finally {
            setIsLoading(false); 
        }

    };

    const handleExportKYC = async () => {
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api1/kYC/kYCToExport`, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Pending_creditCheck_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert('Export Pending KYC Data successfully');
        } catch (error) {
            console.error('Error generating export:', error.response?.data || error.message);
            alert('Export Pending KYC Data failed');
        } finally {
            setIsDownloading(false);
        }
    };

    const fetchKYCData = async (status) => {
        try {
            const response = await axios.get(`${base_url}/api1/customer/customerStatus?status=${status}`);
            const data = response.data.map(item => ({ ...item, actionPerformed: false }));
            return data.reverse();
        } catch (error) {
            console.error(`Error fetching ${status} data:`, error);
            return [];
        }
    };

    useEffect(() => {
        const loadData = async () => {
            if (showKYCCheck) {
                const data = await fetchKYCData('Kyc complete');
                setKYCCheck(data);
            } else if (showKYCFaild) {
                const data = await fetchKYCData('Kyc Faild');
                setKYCFaild(data);
            }
        };

        loadData();
    }, [showKYCCheck, showKYCFaild]);

    const handleShowKYCCheck = () => {
        setShowKYCCheck(true);
        setShowKYCFaild(false);
    };

    const handleShowKYCFaild = () => {
        setShowKYCFaild(true);
        setShowKYCCheck(false);
    };

     
// search filter API 
const handleSearch = (event) => {
    event.preventDefault();
    if (searchOption && searchInput) {
        let url = '';
        switch (searchOption) {
            case 'borrower_name':
                url = `${base_url}/api1/customer/searchByBorrowerName?borrowerName=${searchInput}`;
                break;
            case 'borrower_id':
                url = `${base_url}/api1/customer/searchByBorrowerId?borrowerId=${searchInput}`;
                break;
            case 'phone':
                url = `${base_url}/api1/customer/searchByMobileNumber?mobileNumber=${searchInput}`;
                break;
            default:
                break;
        }
        axios.get(url).then(
            (response) => {
                console.log(response.data);
                setKYCCheck(response.data);
            },
            (error) => {
                console.log(error);
            }
        );
    }
};

// search filter API end 
    return (
        <>
            <div className='overviewsaa'>
                <h4>KYC Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form name="searchForm">
                                            <div className='row'>
                                            <div className="col-md-2 col-3">
                                                    <div className=" required">
                                                        <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required="required">
                                                            <option value="" selected="selected">Search By</option>
                                                            <option value="borrower_name">Borrower Name</option>
                                                            <option value="borrower_id">Partner Id</option>
                                                            <option value="phone">Phone</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-6">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)}required/>
                                                    </div>
                                                </div>
                                                <div className="col-md-1 col-3">
                                                    <div className=" required iconsss">
                                                        <button type="submit" onClick={handleSearch} className="btn btn-sm btn-primary">Search</button>
                                                    </div>
                                                </div>
                                                <div className='col-md-2 col-5 mt-2'>
                                                    <div className='rejectlist'>
                                                        <NavLink onClick={handleShowKYCCheck} to="#">KYC Checked</NavLink>
                                                    </div>
                                                </div>
                                                <div className='col-md-2 col-4 mt-2'>
                                                    <div className='rejectlist'>
                                                        <NavLink to="#" onClick={handleShowKYCFaild} >KYC Reject</NavLink>
                                                    </div>
                                                </div>
                                                <div className="col-md-1 col-3 mt-2">
                                                    <div className="export">
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportKYC}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                    Export 
                                                                </>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='kyc table-responsive allcustomer mt-3 mb-5'>
                                        {showKYCFaild && kYCFaild.length > 0 && (
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>Salora_Id</th>
                                                        <th>Emp_Id</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Date_of_Birth</th>
                                                        <th>Pan_Number</th>
                                                        <th>Phone_Number</th>
                                                        <th>aadhar_number</th>
                                                        <th>Account_Number</th>
                                                        <th>IFSC_Code</th>
                                                    </tr>
                                                    {kYCFaild.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.id}</td>
                                                            <td>{data.empId}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.dob}</td>
                                                            <td>{data.panNumber}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.aadharNumber}</td>
                                                            <td>{data.accountNumber}</td>
                                                            <td>{data.ifscCode}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                        {showKYCFaild && kYCFaild.length === 0 && (
                                            "No Rejected CreditCheck today."
                                        )}
                                        {showKYCCheck && kYCCheck.length > 0 && (
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>Salora_Id</th>
                                                        <th>Emp_Id</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Date_of_Birth</th>
                                                        <th>Pan_Number</th>
                                                        <th>Phone_Number</th>
                                                        <th>Aadhar_Number</th>
                                                        <th>Account_Number</th>
                                                        <th>IFSC_Code</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {kYCCheck.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.id}</td>
                                                            <td>{data.empId}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.dob}</td>
                                                            <td>{data.panNumber}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.aadharNumber}</td>
                                                            <td>{data.accountNumber}</td>
                                                            <td>{data.ifscCode}</td>
                                                            <td className='creditcheck'> 
                                                                <button onClick={() => handleBankVerification(data)} disabled={data.actionPerformed || isLoading}  >
                                                             {isLoading ? "Processing..." : "Account_Check"}
                                                            </button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                        {showKYCCheck && kYCCheck.length === 0 && (
                                            "No CreditCheck completed today."
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default KYC;
